const en = {
  // Common
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    confirm: 'Confirm',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    and: 'and',
    all: 'All',
    none: 'None',
    select: 'Select',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    settings: 'Settings',
    help: 'Help',
    logout: 'Logout',
    login: 'Login',
    signUp: 'Sign Up',
    email: 'Email',
    password: 'Password',
    username: 'Username',
    name: 'Name',
    phone: 'Phone',
    address: 'Address',
    description: 'Description',
    date: 'Date',
    time: 'Time',
    total: 'Total',
    amount: 'Amount',
    price: 'Price',
    quantity: 'Quantity',
    download: 'Download',
    upload: 'Upload',
    refresh: 'Refresh',
    view: 'View',
    details: 'Details',
    more: 'More',
    less: 'Less',
    new: 'NEW',
    testimonials: 'Testimonials',
    getStartedFree: 'Get Started for Free',
    scheduleDemo: 'Schedule a Demo',
    simpleProcess: 'Simple Process',
    allRightsReserved: 'All rights reserved.',
  },

  // Navigation
  nav: {
    home: 'Home',
    pricing: 'Pricing',
    contact: 'Contact Us',
    integrations: 'Integrations',
    docs: 'Documentation',
    releases: 'Releases',
    bookDemo: 'Book a Demo',
    bookAppointment: 'Book an Appointment',
    solutions: 'Solutions',
    getStarted: 'Get Started',
    dashboard: 'Dashboard',
    voiceAgents: 'Voice Agents',
    campaigns: 'Campaigns',
    analytics: 'Analytics',
    users: 'Users',
    settings: 'Settings',
    billing: 'Billing',
    reports: 'Reports',
    leads: 'Leads',
    files: 'Files',
    cloneVoice: 'Clone Voice',
    dialer: 'Auto Dialer',
    dnc: 'DNC List',
    agentMonitor: 'Agent Monitor',
  },

  // Home Page
  home: {
    heroTitle: 'AI-Powered Voice Agents for Your Business',
    heroSubtitle: 'Automate customer interactions with intelligent voice AI that sounds natural and handles complex conversations.',
    getStarted: 'Get Started Free',
    watchDemo: 'Watch Demo',
    trustedBy: 'Trusted by leading companies',
    features: {
      title: 'Powerful Features',
      subtitle: 'Everything you need to automate voice communications',
      aiVoice: {
        title: 'AI Voice Agents',
        description: 'Natural-sounding AI agents that handle calls 24/7 with human-like conversation abilities.',
      },
      autoDialer: {
        title: 'Auto Dialer',
        description: 'Automated outbound calling campaigns with intelligent pacing and lead management.',
      },
      analytics: {
        title: 'Advanced Analytics',
        description: 'Real-time insights into call performance, conversion rates, and agent effectiveness.',
      },
      integrations: {
        title: 'Seamless Integrations',
        description: 'Connect with your CRM, calendar, and other tools for streamlined workflows.',
      },
      voiceCloning: {
        title: 'Voice Cloning',
        description: 'Create custom AI voices that match your brand identity and tone.',
      },
      multiLanguage: {
        title: 'Multi-Language Support',
        description: 'Support for multiple languages including English, Russian, and Uzbek.',
      },
    },
    cta: {
      title: 'Ready to Transform Your Voice Communications?',
      subtitle: 'Start your free trial today and see the difference AI can make.',
      button: 'Start Free Trial',
    },
  },

  // Auth
  auth: {
    login: 'Login',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    logout: 'Logout',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    emailPlaceholder: 'Enter your email',
    passwordPlaceholder: 'Enter your password',
    usernamePlaceholder: 'Enter your username',
    rememberMe: 'Remember me',
    loginSuccess: 'Login successful!',
    loginError: 'Invalid credentials. Please try again.',
    logoutSuccess: 'You have been logged out.',
    welcomeBack: 'Welcome back!',
    signInToContinue: 'Sign in to continue to your dashboard',
    adminLogin: 'Admin Login',
    clientLogin: 'Client Login',
    userLogin: 'User Login',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome, {name}!',
    overview: 'Overview',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    stats: {
      totalCalls: 'Total Calls',
      answeredCalls: 'Answered',
      missedCalls: 'Missed',
      avgDuration: 'Avg Duration',
      conversionRate: 'Conversion Rate',
      activeAgents: 'Active Agents',
      activeCampaigns: 'Active Campaigns',
      totalLeads: 'Total Leads',
    },
  },

  // Voice Agents
  voiceAgents: {
    title: 'Voice Agents',
    createAgent: 'Create Agent',
    editAgent: 'Edit Agent',
    deleteAgent: 'Delete Agent',
    agentName: 'Agent Name',
    agentVoice: 'Voice',
    agentLanguage: 'Language',
    agentScript: 'Script',
    agentStatus: 'Status',
    testAgent: 'Test Agent',
    testWithChat: 'Test with Chat',
    testWithWeb: 'Test with Web Call',
    testWithPhone: 'Test with Phone Call',
    voiceProvider: 'Voice Provider',
    voicePreview: 'Preview Voice',
    welcomeMessage: 'Welcome Message',
    conversationalFlow: 'Conversational Flow',
    transferSettings: 'Transfer Settings',
    enableTransfer: 'Enable Call Transfer',
    transferNumber: 'Transfer Phone Number',
    noAgents: 'No voice agents yet. Create your first agent to get started.',
  },

  // Campaigns
  campaigns: {
    title: 'Campaigns',
    createCampaign: 'Create Campaign',
    editCampaign: 'Edit Campaign',
    deleteCampaign: 'Delete Campaign',
    campaignName: 'Campaign Name',
    campaignStatus: 'Status',
    campaignType: 'Type',
    startCampaign: 'Start Campaign',
    pauseCampaign: 'Pause Campaign',
    stopCampaign: 'Stop Campaign',
    contacts: 'Contacts',
    dialed: 'Dialed',
    answered: 'Answered',
    noAnswer: 'No Answer',
    busy: 'Busy',
    failed: 'Failed',
    transferred: 'Transferred',
    completed: 'Completed',
    progress: 'Progress',
    uploadContacts: 'Upload Contacts',
    selectAgent: 'Select Voice Agent',
    dialDelay: 'Dial Delay (seconds)',
    maxConcurrent: 'Max Concurrent Calls',
    noCampaigns: 'No campaigns yet. Create your first campaign to start dialing.',
    health: 'Campaign Health',
  },

  // Analytics
  analytics: {
    title: 'Analytics',
    overview: 'Overview',
    callAnalytics: 'Call Analytics',
    voiceAnalytics: 'Voice Analytics',
    performanceMetrics: 'Performance Metrics',
    dateRange: 'Date Range',
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    custom: 'Custom Range',
    exportReport: 'Export Report',
    callVolume: 'Call Volume',
    successRate: 'Success Rate',
    avgCallDuration: 'Avg Call Duration',
    peakHours: 'Peak Hours',
  },

  // Users
  users: {
    title: 'Users',
    createUser: 'Create User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    userName: 'User Name',
    userEmail: 'Email',
    userRole: 'Role',
    userStatus: 'Status',
    lastLogin: 'Last Login',
    assignedPhone: 'Assigned Phone',
    availability: 'Availability',
    available: 'Available',
    busy: 'Busy',
    offline: 'Offline',
    noUsers: 'No users yet. Add your first user to get started.',
  },

  // Settings
  settings: {
    title: 'Settings',
    general: 'General',
    account: 'Account',
    notifications: 'Notifications',
    security: 'Security',
    integrations: 'Integrations',
    billing: 'Billing',
    api: 'API',
    timezone: 'Timezone',
    language: 'Language',
    theme: 'Theme',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    saveChanges: 'Save Changes',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
  },

  // Integrations
  integrations: {
    title: 'Integrations',
    subtitle: 'Connect with your favorite tools and platforms',
    ecosystem: 'Ecosystem',
    connected: 'Connected',
    notConnected: 'Not Connected',
    connect: 'Connect',
    disconnect: 'Disconnect',
    configure: 'Configure',
    testConnection: 'Test Connection',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    webhookUrl: 'Webhook URL',
    categories: {
      crm: 'CRM',
      calendar: 'Calendar',
      messaging: 'Messaging',
      analytics: 'Analytics',
      contactCenter: 'Contact Center',
      other: 'Other',
    },
  },

  // Billing
  billing: {
    title: 'Billing',
    currentPlan: 'Current Plan',
    usage: 'Usage',
    invoices: 'Invoices',
    paymentMethods: 'Payment Methods',
    upgradePlan: 'Upgrade Plan',
    cancelSubscription: 'Cancel Subscription',
    billingHistory: 'Billing History',
    nextBillingDate: 'Next Billing Date',
    minutesUsed: 'Minutes Used',
    minutesRemaining: 'Minutes Remaining',
  },

  // Leads
  leads: {
    title: 'Leads',
    createLead: 'Create Lead',
    importLeads: 'Import Leads',
    exportLeads: 'Export Leads',
    leadName: 'Lead Name',
    leadPhone: 'Phone',
    leadEmail: 'Email',
    leadStatus: 'Status',
    leadSource: 'Source',
    new: 'New',
    contacted: 'Contacted',
    qualified: 'Qualified',
    converted: 'Converted',
    lost: 'Lost',
    noLeads: 'No leads yet. Import or create leads to get started.',
  },

  // Files
  files: {
    title: 'Files',
    uploadFile: 'Upload File',
    deleteFile: 'Delete File',
    fileName: 'File Name',
    fileSize: 'Size',
    fileType: 'Type',
    uploadedAt: 'Uploaded',
    noFiles: 'No files uploaded yet.',
    dragDrop: 'Drag and drop files here or click to browse',
    supportedFormats: 'Supported formats: CSV, XLS, XLSX',
  },

  // Errors
  errors: {
    somethingWentWrong: 'Something went wrong. Please try again.',
    pageNotFound: 'Page not found',
    unauthorized: 'You are not authorized to access this page.',
    sessionExpired: 'Your session has expired. Please login again.',
    networkError: 'Network error. Please check your connection.',
    validationError: 'Please check your input and try again.',
    serverError: 'Server error. Please try again later.',
  },

  // Success Messages
  success: {
    saved: 'Changes saved successfully!',
    created: 'Created successfully!',
    updated: 'Updated successfully!',
    deleted: 'Deleted successfully!',
    uploaded: 'File uploaded successfully!',
    imported: 'Data imported successfully!',
    exported: 'Data exported successfully!',
    copied: 'Copied to clipboard!',
  },

  // Confirmation
  confirm: {
    delete: 'Are you sure you want to delete this?',
    cancel: 'Are you sure you want to cancel?',
    logout: 'Are you sure you want to logout?',
    discard: 'Discard unsaved changes?',
  },

  // Footer
  footer: {
    copyright: '© {year} AIConneqtors. All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    contact: 'Contact Us',
    about: 'About Us',
    description: 'Build, test, and ship conversational AI systems with no-code tools and APIs.',
    product: 'Product',
    features: 'Features',
    resources: 'Resources',
    apiReference: 'API Reference',
    blog: 'Blog',
    helpCenter: 'Help Center',
    company: 'Company',
    cookies: 'Cookies',
  },

  // Language Selector
  languageSelector: {
    title: 'Select Language',
    current: 'Current Language',
  },

  // Header
  header: {
    announcement: 'You can now buy phone numbers in AIConneqtors!',
    viewUpdate: 'View Update',
    admin: 'Admin',
  },

  // Hero Section
  hero: {
    title: 'Create your',
    free: 'Free',
    voiceAI: 'Voice AI',
    assistant: 'Assistant',
    subtitle: 'Build, test, and ship reliable voice AI assistants',
    placeholder: 'Describe your ideal Voice AI Assistant',
    guidedFlow: 'Guided Flow',
    createAgent: 'Create Agent',
    chooseUseCase: 'Choose from use cases',
    useCases: ['Lead Generation', 'Appointments', 'Support', 'Negotiation', 'Collections']
  },

  // Core Capabilities
  capabilities: {
    title: 'Core Capabilities',
    heading: 'Why AIConneqtors for',
    voiceAI: 'Voice AI',
    subtitle: 'Powerful features to build, deploy, and scale your Voice AI assistants',
    selectLanguage: 'Select a language',
    features: [
      {
        icon: 'Languages',
        title: 'Multi-Language',
        description: 'Serve users in 50+ languages worldwide'
      },
      {
        icon: 'ArrowUpRight',
        title: 'Scale Outbound',
        description: 'Automate lead gen, reminders & collections'
      },
      {
        icon: 'Clock',
        title: '24/7 Inbound',
        description: 'Handle bookings and inquiries around the clock'
      },
      {
        icon: 'Plug',
        title: 'Connect Stack',
        description: 'Integrate with CRM, Sheets, Slack, n8n'
      },
      {
        icon: 'GraduationCap',
        title: 'Quick Training',
        description: 'Train AI with your own call recordings'
      },
      {
        icon: 'Phone',
        title: 'Phone Numbers',
        description: 'Buy US (+1) numbers instantly'
      }
    ]
  },

  // User Dashboard
  userDashboard: {
    title: 'Agent Portal',
    welcome: 'Welcome back',
    welcomeSubtitle: 'Receive and manage transferred calls from AI agents',
    softphoneSetup: 'Softphone Setup (Zoiper/Linphone)',
    yourPhone: 'Your Phone',
    notAssigned: 'Not assigned',
    downloadZoiper: 'Download Zoiper',
    sipDescription: 'Use these SIP credentials to configure Zoiper, Linphone, or any SIP-compatible softphone to receive transferred calls from AI agents.',
    sipServer: 'SIP Server / Domain',
    username: 'Username / SIP ID',
    password: 'Password',
    outboundProxy: 'Outbound Proxy (optional)',
    setupInstructions: 'Setup Instructions',
    callsWillBeTransferred: 'Calls will be transferred to your softphone when AI detects transfer intent',
    availability: 'Availability',
    available: 'Available',
    busy: 'Busy',
    callsToday: 'Calls Today',
    minutesUsed: 'Minutes Used',
    plan: 'Plan',
    voiceAgents: 'Your Voice AI Agents',
    noAgentsAssigned: 'No agents assigned',
    contactAdmin: 'Contact your administrator to get agents assigned to your account',
    testCall: 'Test Call',
    recentCalls: 'Recent Calls',
    upgradePlan: 'Upgrade Your Plan',
    moreMinutes: 'Get more minutes and unlock premium features',
    viewAllPlans: 'View all plans',
    lowMinutes: 'Low minutes! Only',
    minRemaining: 'min remaining',
    upgrade: 'Upgrade',
    demoMode: 'Demo Mode',
    callsSimulated: 'Calls are simulated. Real calling requires Telnyx API key.',
    phoneToCall: 'Phone Number to Call',
  },

  // Desktop Notifications
  notifications: {
    enableTitle: 'Enable Desktop Notifications',
    enableDescription: 'Get alerted when calls come in, even when this tab is in the background',
    enable: 'Enable',
    incomingCall: 'Incoming Call',
    callFrom: 'Call from',
    clickToAnswer: 'Click to answer',
  },

  // Zoiper Setup Steps
  zoiperSetup: {
    download: 'Download and install Zoiper from',
    openZoiper: 'Open Zoiper and click "Create Account" → "Yes" (I have credentials)',
    enterCredentials: 'Enter your Username and Password from above',
    forProvider: 'For Provider, enter:',
    skipOptional: 'Skip optional settings and click "Create"',
    waitReady: 'Wait for the account to show "Ready" or green status',
    keepRunning: 'Keep Zoiper running to receive incoming calls',
  },

  // Linphone Setup Steps
  linphoneSetup: {
    download: 'Download Linphone from',
    goToSettings: 'Go to Settings → Account → Add Account',
    selectSIP: 'Select "I have a SIP account"',
    enterDetails: 'Enter Username, Password, and Domain (sip.telnyx.com)',
    saveWait: 'Save and wait for registration',
  },

  // Sidebar
  sidebar: {
    clientPortal: 'Client Portal',
    client: 'Client',
    clientAdmin: 'Client Admin',
    plan: 'Plan',
    voiceAiSetup: 'VOICE AI SETUP',
    operationsMonitoring: 'OPERATIONS & MONITORING',
    monitoring: 'MONITORING',
    management: 'MANAGEMENT',
    accountBilling: 'ACCOUNT & BILLING',
    phoneNumbers: 'Phone Numbers',
    callLogs: 'Call Logs',
    campaignHealth: 'Campaign Health',
    voiceAnalytics: 'Voice Analytics',
    usageQuotas: 'Usage & Quotas',
    dialerPortal: 'Dialer Portal',
    restrictedFeatures: 'Some features may be restricted',
    telnyxSettings: 'Telnyx Settings',
  },

  // Client Dashboard
  clientDashboard: {
    totalUsers: 'Total Users',
    activeAgents: 'Active Agents',
    totalCalls: 'Total Calls',
    subtitle: 'Manage your users and AI voice agents from this dashboard',
    recentAgents: 'Recent Voice Agents',
    noAgentsYet: 'No agents yet. Create your first voice agent.',
    createAgentDesc: 'Set up a new AI voice assistant',
    manageUsers: 'Manage Users',
    manageUsersDesc: 'Add or edit your team members',
  },

  // Voice Agents Page
  voiceAgents: {
    title: 'Voice AI Agents',
    subtitle: 'Create and manage your AI voice assistants',
    createAgent: 'Create Agent',
    refresh: 'Refresh',
    agentQuota: 'Agent Quota',
    noSlotsRemaining: 'No slots remaining. Contact your administrator to upgrade.',
    slotsRemaining: 'agent slot(s) remaining',
    searchPlaceholder: 'Search agents by name or language...',
    noAgentsFound: 'No agents found. Click "Create Agent" to get started.',
    loadingAgents: 'Loading agents...',
    editAgent: 'Edit Agent',
    viewScript: 'View Script',
    deleteAgent: 'Delete Agent',
    confirmDelete: 'Are you sure you want to delete this agent?',
    agentDeleted: 'Agent deleted successfully',
    agentCreated: 'Agent created successfully',
    agentUpdated: 'Agent updated successfully',
    limitReached: 'Agent limit reached. Contact your administrator to upgrade your plan.',
    calls: 'calls',
    status: 'Status',
    language: 'Language',
    voice: 'Voice',
    script: 'Script',
    greeting: 'Greeting',
    description: 'Description',
    name: 'Name',
    advancedSettings: 'Advanced Settings',
    fullEditor: 'Full Editor',
  },

  // Campaigns Page
  campaigns: {
    title: 'Auto-Dial Campaigns',
    subtitle: 'Upload contact lists and automatically dial numbers with AI agents',
    newCampaign: 'New Campaign',
    createCampaign: 'Create Campaign',
    noCampaigns: 'No Campaigns',
    createFirstCampaign: 'Create your first auto-dial campaign to get started',
    contacts: 'contacts',
    agent: 'Agent',
    delay: 'delay',
    scheduled: 'Scheduled',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    nextRun: 'Next',
    runs: 'runs',
    progress: 'Progress',
    viewDetails: 'View Details',
    start: 'Start',
    pause: 'Pause',
    stop: 'Stop',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete this campaign?',
    noDescription: 'No description',
    filterAll: 'All',
    filterDraft: 'Draft',
    filterScheduled: 'Scheduled',
    filterRunning: 'Running',
    filterPaused: 'Paused',
    filterStopped: 'Stopped',
    filterCompleted: 'Completed',
    filterCancelled: 'Cancelled',
  },

  // Analytics Page
  analytics: {
    title: 'Analytics Dashboard',
    subtitle: 'Call metrics and performance insights',
    lastDays: 'Last {days} days',
    last7Days: 'Last 7 days',
    last14Days: 'Last 14 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    totalCalls: 'Total Calls',
    answered: 'Answered',
    avgDuration: 'Avg Duration',
    talkTime: 'Talk Time',
    outbound: 'Outbound',
    inbound: 'Inbound',
    answeredCalls: 'Answered Calls',
    answerRate: 'Answer Rate',
    peakHour: 'Peak Hour',
    callOutcomes: 'Call Outcomes',
    noAnswer: 'No Answer',
    busy: 'Busy',
    failed: 'Failed',
    durationDistribution: 'Duration Distribution',
    under1Min: 'Under 1m',
    oneToFiveMins: '1-5m',
    fiveToTenMins: '5-10m',
    overTenMins: '10m+',
    campaignPerformance: 'Campaign Performance',
    noCampaigns: 'No campaigns found',
    recentCallsWithRecordings: 'Recent Calls with Recordings',
    noCallsFound: 'No calls with recordings found',
    playRecording: 'Play Recording',
    viewTranscript: 'View Transcript',
    loading: 'Loading analytics...',
    retry: 'Retry',
    failedToLoad: 'Failed to load analytics data',
  },

  // Telnyx Settings
  telnyxSettings: {
    title: 'Telnyx Configuration',
    subtitle: 'Use your own Telnyx account for calls and billing isolation',
    configTitle: 'Your Telnyx Credentials',
    callerID: 'Caller ID',
    enableOwn: 'Use my own Telnyx account',
    enableDesc: 'When enabled, campaigns will use your Telnyx credentials instead of the system default',
    apiKey: 'API Key',
    apiKeyPlaceholder: 'Enter your Telnyx API Key',
    apiKeyRequired: 'API Key is required',
    apiKeyHelp: 'Get your API key from the',
    connectionId: 'Connection ID (Call Control App)',
    connectionIdPlaceholder: 'Enter your Call Control Application ID',
    connectionIdHelp: 'The ID of your Call Control Application in Telnyx',
    phoneNumber: 'Phone Number',
    phoneNumberHelp: 'The outbound caller ID phone number from your Telnyx account',
    verified: 'Verified',
    notVerified: 'Not Verified',
    verify: 'Verify Credentials',
    useSystem: 'Use System Default',
    saveSuccess: 'Telnyx configuration saved successfully',
    saveError: 'Failed to save configuration',
    verifySuccess: 'Credentials verified successfully',
    verifyFailed: 'Credentials verification failed',
    verifyError: 'Error verifying credentials',
    deleteSuccess: 'Configuration removed. Using system default.',
    deleteError: 'Failed to remove configuration',
    confirmDelete: 'Are you sure you want to remove your Telnyx configuration and use the system default?',
    helpTitle: 'How it works',
    help1: '1. Enter your Telnyx API Key, Connection ID, and Phone Number',
    help2: '2. Click "Save" to store your credentials securely',
    help3: '3. All your campaigns will now use your own Telnyx account for billing',
  },

  // Voice Analytics Dashboard
  voiceAnalytics: {
    title: 'Voice Analytics',
    subtitle: 'Advanced call analysis and insights',
    exportPdf: 'Export PDF',
    tabOverview: 'Overview',
    tabTalkTime: 'Talk Time',
    tabKeywords: 'Keywords',
    tabOutcomes: 'Outcomes',
    tabAiInsights: 'AI Insights',
    tabPerformance: 'Performance',
    tabCompare: 'Compare',
    totalCalls: 'Total Calls',
    talkTime: 'Talk Time',
    answerRate: 'Answer Rate',
    transferRate: 'Transfer Rate',
    hourlyDistribution: 'Hourly Call Distribution',
    durationDistribution: 'Call Duration Distribution',
    dailyTrends: 'Daily Call Trends',
    peakAnalysis: 'Peak Analysis',
    peakHour: 'Peak Hour',
    peakDay: 'Peak Day',
    callsAtPeak: 'calls',
    avgDuration: 'Average Duration',
    minDuration: 'Min Duration',
    maxDuration: 'Max Duration',
    topKeywords: 'Top Keywords',
    keywordsOverall: 'Overall',
    keywordsCustomer: 'From Customers',
    keywordsAgent: 'From Agents',
    phraseAnalysis: 'Phrase Analysis',
    transferRequests: 'Transfer Requests',
    positiveSentiment: 'Positive Sentiment',
    negativeSentiment: 'Negative Sentiment',
    outcomeDistribution: 'Outcome Distribution',
    statusDistribution: 'Status Distribution',
    agentPerformance: 'Agent Performance',
    conversionFunnel: 'Conversion Funnel',
    dialed: 'Dialed',
    answered: 'Answered',
    completed: 'Completed',
    customerSatisfaction: 'Customer Satisfaction',
    topIntent: 'Top Intent',
    objectionRate: 'Objection Rate',
    intentTrends: 'Intent Detection Trends',
    topObjections: 'Top Objections',
    noDataAvailable: 'No Data Available',
    noDataMessage: 'AI insights will appear here once you have call data to analyze.',
    bestTimeSlots: 'Best Time Slots',
    performanceByLanguage: 'Performance by Language',
    calls: 'calls',
    successRate: 'success rate',
  },

  // FAQ Section
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Common questions about the AIConneqtors platform',
    questions: [
      {
        question: 'How quickly can I really create a Voice AI agent?',
        answer: 'You can create a fully functional Voice AI agent on AIConneqtors in under 5 minutes. Just prompt, pick a voice, and launch. No coding required.'
      },
      {
        question: 'Do I need any technical or coding knowledge?',
        answer: 'Not at all. AIConneqtors is built for everyone, from business owners to developers. You can create, test, and deploy AI agents without writing a single line of code.'
      },
      {
        question: 'What kind of Voice AI agents can I build?',
        answer: 'On AIConneqtors, you can build customer support bots, lead generation agents, appointment schedulers, sales assistants, IVR systems, and more. If your business talks to customers, you can automate it here.'
      },
      {
        question: 'Can I customize how the AI agent sounds and responds?',
        answer: 'Absolutely. AIConneqtors lets you choose from a variety of natural voices, tones, speaking speeds, and emotional styles. You can also edit the agent\'s conversation flow and personality to match your brand.'
      },
      {
        question: 'What happens after I create my agent?',
        answer: 'Once created on AIConneqtors, you can instantly test your agent, deploy it on calls or your website, and track live analytics on performance and user engagement.'
      },
      {
        question: 'Is there a free trial or demo available?',
        answer: 'Yes. You can sign up for a free trial on AIConneqtors to create your first agent and experience the platform before upgrading to a paid plan.'
      },
    ]
  },

  // How It Works Section
  howItWorks: {
    title: 'How It Works',
    subtitle: 'Get started with AIConneqtors in three simple steps',
    stepButtons: [
      { step: 1, icon: 'PenLine', title: 'Write', description: 'Describe what type of Voice AI assistant you want' },
      { step: 2, icon: 'FlaskConical', title: 'Test', description: 'Try out your assistant and see how it performs' },
      { step: 3, icon: 'Puzzle', title: 'Add Functionalities', description: 'Enhance through chat and drag-and-drop' },
      { step: 4, icon: 'Rocket', title: 'Deploy', description: 'Make your assistant available to your users' },
      { step: 5, icon: 'LineChart', title: 'Observe & Monitor', description: 'Track performance and make improvements' }
    ],
    steps: [
      {
        number: '01',
        title: 'Create Your Agent',
        description: 'Describe your ideal AI assistant using natural language. Choose voice, personality, and behavior.'
      },
      {
        number: '02',
        title: 'Configure & Test',
        description: 'Set up call flows, integrations, and test your agent with real conversations before going live.'
      },
      {
        number: '03',
        title: 'Deploy & Scale',
        description: 'Launch your agent instantly. Handle thousands of calls simultaneously with full analytics.'
      }
    ],
    stepDetails: {
      1: {
        title: 'Create Voice AI Assistants with Natural Language',
        subtitle: 'Simply describe what you want your Voice AI assistant to do, and we\'ll build it for you.',
        features: [
          {
            icon: 'MessageCircle',
            title: 'Conversational Creation',
            description: 'Build your assistant through natural conversation - just chat with our platform about what you need.'
          },
          {
            icon: 'MousePointerSquare',
            title: 'Drag-and-Drop Interface',
            description: 'Fine-tune your assistant\'s capabilities with our intuitive drag-and-drop editor.'
          },
          {
            icon: 'FileText',
            title: 'Pre-built Templates',
            description: 'Start with industry-specific templates and customize to your needs.'
          }
        ]
      },
      2: {
        title: 'Test Your Voice AI Assistant',
        subtitle: 'Preview and test your assistant in real-time before deployment.',
        features: [
          {
            icon: 'Mic',
            title: 'Live Voice Testing',
            description: 'Test your assistant with actual voice commands and hear responses in real-time.'
          },
          {
            icon: 'MessageSquare',
            title: 'Conversation Simulation',
            description: 'Simulate complete conversations to ensure natural flow and accurate responses.'
          },
          {
            icon: 'ClipboardCheck',
            title: 'Quality Assurance',
            description: 'Run automated tests to verify your assistant handles edge cases correctly.'
          }
        ]
      },
      3: {
        title: 'Integrate with Your Systems',
        subtitle: 'Connect your Voice AI assistant with your existing tools and workflows.',
        features: [
          {
            icon: 'Zap',
            title: 'API Integration',
            description: 'Connect to any system using our comprehensive REST API and webhooks.'
          },
          {
            icon: 'Database',
            title: 'CRM Sync',
            description: 'Automatically sync call data and customer information with your CRM.'
          },
          {
            icon: 'GitBranch',
            title: 'Workflow Automation',
            description: 'Trigger actions in other apps based on conversation outcomes.'
          }
        ]
      },
      4: {
        title: 'Deploy and Scale',
        subtitle: 'Launch your assistant and handle thousands of concurrent calls.',
        features: [
          {
            icon: 'Phone',
            title: 'Phone Number Setup',
            description: 'Get dedicated phone numbers or connect your existing numbers instantly.'
          },
          {
            icon: 'Globe',
            title: 'Global Deployment',
            description: 'Deploy to multiple regions for low-latency calls worldwide.'
          },
          {
            icon: 'Share2',
            title: 'Multi-channel Support',
            description: 'Extend your assistant to web, mobile, and messaging platforms.'
          }
        ]
      },
      5: {
        title: 'Monitor and Optimize',
        subtitle: 'Track performance and continuously improve your Voice AI assistant.',
        features: [
          {
            icon: 'BarChart2',
            title: 'Real-time Analytics',
            description: 'Monitor call volumes, success rates, and customer satisfaction live.'
          },
          {
            icon: 'FileSearch',
            title: 'Conversation Insights',
            description: 'Analyze transcripts to understand customer needs and improve responses.'
          },
          {
            icon: 'TrendingUp',
            title: 'AI Learning',
            description: 'Your assistant continuously improves based on real conversations.'
          }
        ]
      }
    }
  },

  // Key Features Section
  keyFeatures: {
    title: 'Key Features',
    subtitle: 'Everything you need to build powerful voice AI solutions',
    features: [
      {
        title: 'Natural Voice Synthesis',
        description: 'Ultra-realistic AI voices that sound human, with customizable tone, speed, and emotion.'
      },
      {
        title: 'Smart Call Routing',
        description: 'Intelligent routing based on intent, sentiment, and customer history.'
      },
      {
        title: 'Real-time Analytics',
        description: 'Live dashboards tracking call metrics, conversion rates, and agent performance.'
      },
      {
        title: 'CRM Integration',
        description: 'Seamless connection with your existing tools - Salesforce, HubSpot, and more.'
      },
      {
        title: 'Multi-language Support',
        description: 'AI agents that speak and understand multiple languages fluently.'
      },
      {
        title: 'Call Recording & Transcription',
        description: 'Automatic recording and transcription of every conversation for training and compliance.'
      }
    ]
  },

  // Testimonials Section
  testimonials: {
    title: 'What Our Customers Say',
    subtitle: 'Trusted by businesses worldwide',
    items: [
      {
        quote: 'AIConneqtors transformed our customer service. We handle 3x more calls with better satisfaction scores.',
        author: 'Sarah Johnson',
        role: 'VP of Customer Success',
        company: 'TechCorp Inc.'
      },
      {
        quote: 'Setting up our AI agent took minutes, not weeks. The ROI was immediate.',
        author: 'Michael Chen',
        role: 'Operations Director',
        company: 'GlobalRetail'
      },
      {
        quote: 'The voice quality is incredible. Our customers often can\'t tell they\'re talking to an AI.',
        author: 'Emily Rodriguez',
        role: 'CEO',
        company: 'StartupXYZ'
      }
    ]
  },

  // Pricing Page
  pricing: {
    title: 'Simple, Transparent Pricing',
    subtitle: 'Choose the plan that fits your business needs',
    monthly: 'Monthly',
    yearly: 'Yearly',
    save: 'Save 20%',
    perMonth: '/month',
    perYear: '/year',
    getStarted: 'Get Started',
    contactSales: 'Contact Sales',
    mostPopular: 'Most Popular',
    features: 'Features',
    plans: {
      starter: {
        name: 'Starter',
        price: '$49',
        description: 'Perfect for small businesses getting started',
        features: [
          '1 AI Voice Agent',
          '500 minutes/month',
          'Basic analytics',
          'Email support',
          'Standard voices'
        ]
      },
      professional: {
        name: 'Professional',
        price: '$149',
        description: 'For growing businesses with higher volume',
        features: [
          '5 AI Voice Agents',
          '2,500 minutes/month',
          'Advanced analytics',
          'Priority support',
          'Premium voices',
          'CRM integrations',
          'Call recording'
        ]
      },
      enterprise: {
        name: 'Enterprise',
        price: 'Custom',
        description: 'For large organizations with custom needs',
        features: [
          'Unlimited AI Agents',
          'Unlimited minutes',
          'Custom analytics',
          'Dedicated support',
          'Custom voices',
          'Full API access',
          'SLA guarantee',
          'On-premise option'
        ]
      }
    }
  },

  // Contact Us Page
  contactUs: {
    title: 'Contact Us',
    subtitle: 'Get in touch with our team',
    form: {
      name: 'Your Name',
      email: 'Email Address',
      company: 'Company Name',
      phone: 'Phone Number',
      subject: 'Subject',
      message: 'Your Message',
      submit: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully! We\'ll get back to you soon.',
      error: 'Failed to send message. Please try again.'
    },
    info: {
      title: 'Get in Touch',
      description: 'Have questions? We\'d love to hear from you.',
      email: 'support@aiconneqtors.com',
      phone: '+1 (888) 123-4567',
      address: 'San Francisco, CA'
    }
  },

  // User Login Page
  userLogin: {
    title: 'Agent Login',
    subtitle: 'Sign in to your agent dashboard',
    username: 'Username',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    forgotPassword: 'Forgot password?',
    noAccount: 'Don\'t have an account?',
    contactAdmin: 'Contact your administrator'
  },

  // Sign Up Page
  signUp: {
    title: 'Create Your Account',
    subtitle: 'Start your free trial today',
    name: 'Full Name',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    company: 'Company Name',
    phone: 'Phone Number',
    createAccount: 'Create Account',
    creating: 'Creating account...',
    haveAccount: 'Already have an account?',
    signIn: 'Sign In',
    terms: 'By signing up, you agree to our Terms of Service and Privacy Policy'
  },

  // Admin Login
  adminLogin: {
    title: 'Admin Login',
    subtitle: 'Access the administration panel',
    username: 'Username',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...'
  },

  // Integrations Page
  integrationsPage: {
    title: 'Integrations',
    subtitle: 'Connect AIConneqtors with your favorite tools',
    searchPlaceholder: 'Search integrations...',
    categories: {
      all: 'All',
      crm: 'CRM',
      communication: 'Communication',
      analytics: 'Analytics',
      automation: 'Automation'
    },
    connectButton: 'Connect',
    connectedBadge: 'Connected',
    learnMore: 'Learn More'
  },

  // Documentation Page
  documentation: {
    title: 'Documentation',
    subtitle: 'Everything you need to get started with AIConneqtors',
    searchPlaceholder: 'Search documentation...',
    gettingStarted: 'Getting Started',
    apiReference: 'API Reference',
    guides: 'Guides',
    tutorials: 'Tutorials',
    faq: 'FAQ'
  },

  // Releases Page
  releases: {
    title: 'Release Notes',
    subtitle: 'Stay updated with the latest features and improvements',
    version: 'Version',
    date: 'Released',
    newFeatures: 'New Features',
    improvements: 'Improvements',
    bugFixes: 'Bug Fixes'
  }
};

export default en;
